var BranchesViewController = function ($scope, $http, $stateParams, $q, $cookies) {
    var vm = this;

    vm.branch = null;
    vm.token = null;

    vm.repos = [];

    vm.rslts = [];
    vm.notFound = [];
    vm.errors = [];
    vm.searchInProgress = false;
    vm.initialized = false;
    vm.showStats = true;

    vm.showSpinner = function () {
        if (!vm.isTokenInCookie()) {
            return false;
        }
        return vm.loading();
    };

    /**
     *  convenience function to denote the 'loading' state.
     */
    vm.loading = function () {
        if (vm.searchInProgress) {
            // console.log('loading...[searchInProgress]');
            return true;
        }
        var rsltsLoading =
            !!vm.branch &&
            vm.branch.length > 0 &&
            !!vm.token &&
            vm.token.length > 0 &&
            vm.getResultsCount() > 0 &&
            vm.getResultsCount() < vm.getRepoCount() &&
            vm.getRepoCount() > 0;

        //console.log('loading.....',rsltsLoading, vm.branch, !!vm.token, vm.getRepoCount(), vm.getResultsCount());
        return rsltsLoading;
    };

    vm.getResultsCount = function () {
        return vm.rslts.length + vm.errors.length + vm.notFound.length;
    };

    /**
     * clear branch & results inputs.
     */
    vm.clear = function () {
        console.log("clear()");
        vm.rslts = [];
        vm.notFound = [];
        vm.errors = [];
    };

    vm.selectGroup = function () {
        console.log("Group Selected ", vm.selectedGroup);
        if (!!vm.selectedGroup && vm.selectedGroup.length > 0) {
            if (vm.isTokenInCookie()) {
                console.log("populating repo list...");
                //load the repos...
                vm.clear();
                vm.populateRepos(vm.selectedGroup);
            }
        }
    };

    /**
     * init.
     * get listing of repos & gitlab configs.
     * also, determine the target number of repos to include in the search.
     */
    vm.init = function () {
        vm.gitLabCfg = require("./gitlab.json");

        vm.groups = require("./groups.json");

        //branch
        if ($stateParams.branch) {
            vm.branch = $stateParams.branch;
        }

        //token
        if (vm.isTokenInCookie()) {
            vm.token = $cookies.get("gitToken");
            console.log("token found in cookie", vm.token);
        }

        vm.initialized = true;
    };

    vm.getRepoCount = function () {
        var repoCount = 0;
        if (!!vm.repos) {
            for (var i = 0; i < vm.repos.length; i++) {
                if (vm.repos[i].repos) {
                    repoCount += vm.repos[i].repos.length;
                }
            }
        }

        return repoCount;
    };

    vm.getGroupRepos = function (groupName, page) {
        var url =
            vm.gitLabCfg.baseUrl +
            "/" +
            vm.gitLabCfg.apiUri +
            "/groups/" +
            groupName +
            "/projects?simple=true&order_by=name&pagination=keyset&page=" +
            (page + 1) +
            "&per_page=1000&sort=asc";
        console.log("Retrieving group projects", groupName, page + 1, url);
        $http.get(url, vm.config).then(
            function (response) {
                console.log("group projects response:", groupName, page + 1, response.data);

                if (response && response.data) {
                    var projects = response.data;

                    for (var i = 0; i < projects.length; i++) {
                        var repo = {
                            name: projects[i].name,
                            id: projects[i].id
                        };

                        for (var j = 0; j < vm.repos.length; j++) {
                            if (vm.repos[j].group === groupName) {
                                vm.repos[j].repos.push(repo);
                                break;
                            }
                        }
                    }
                }
            },
            function errorCallback(response) {
                vm.errors.push("Error determining group projects for [" + groupName + "] : " + url);
                console.error(
                    "Error determining group projects for [" + groupName + "] : " + url,
                    response
                );
            }
        );
    };

    vm.populateRepos = function (selectedGroup) {
        vm.repos = [];

        console.log("populating group repos", selectedGroup);

        vm.config = {
            headers: {
                "PRIVATE-TOKEN": vm.token,
                Accept: "application/json"
            }
        };

        angular.forEach(vm.groups, function (groupName) {
            if (groupName === selectedGroup) {
                var getProjectsUrl =
                    vm.gitLabCfg.baseUrl +
                    "/" +
                    vm.gitLabCfg.apiUri +
                    "/groups/" +
                    groupName +
                    "/projects?simple=true&order_by=name&pagination=keyset&per_page=1000&sort=asc";
                console.log("Retrieving group projects for pages", groupName, getProjectsUrl);
                $http.get(getProjectsUrl, vm.config).then(
                    function (response) {
                        //console.log('group projects response headers',response.headers());
                        var totalPages = response.headers()["x-total-pages"];
                        console.log("group pages", groupName, totalPages);
                        if (!!totalPages && totalPages > 0) {
                            vm.repos.push({ group: groupName, repos: [] });
                            for (var page = 0; page < totalPages; page++) {
                                vm.getGroupRepos(groupName, page);
                            } //end for pages
                        }
                    },
                    function errorCallback(response) {
                        vm.errors.push(
                            "Unable to determine group projects for [" +
                                groupName +
                                "] : " +
                                getProjectsUrl
                        );
                        console.error(
                            "Unable to determine group projects for [" +
                                groupName +
                                "] : " +
                                getProjectsUrl,
                            response
                        );
                    }
                );
            }
        });
    };

    vm.isTokenInCookie = function () {
        return $cookies.get("gitToken") != null;
    };

    vm.clearToken = function () {
        //console.log('removing token cookie');
        $cookies.remove("gitToken", { path: "/" });
    };

    vm.reposLoaded = function () {
        return vm.repos.length === vm.groups.length;
    };

    /**
     * iterate over all the repos to and see if they contain a branch w/a  name matching the vm.branch
     */
    vm.doSearch = function () {
        console.log("doSearch()", vm.token, vm.branch, vm.reposLoaded());
        if (vm.token) {
            console.log("token found in memory..");

            //set token into cookie if wasn't there and was just used successfully.
            if (!vm.isTokenInCookie()) {
                console.log("setting provided token to cookie");
                $cookies.put("gitToken", vm.token, { path: "/" });
            }
        }

        console.log("delegating to search..");
        vm.doActualSearch();
    };

    vm.doActualSearch = function () {
        console.log("doActualSearch()", vm.token, vm.branch, vm.repos);

        if (!vm.token) {
            console.error("missing token!");
            return;
        }

        if (!vm.branch) {
            console.error("missing branch name!");
            return;
        }

        if (!vm.repos) {
            console.error("missing repos!!");
            return;
        }

        vm.searchInProgress = true;
        var branchName = vm.branch.replace(/\//g, "%2F");

        vm.rslts = [];
        vm.notFound = [];
        vm.errors = [];
        vm.accessError = null;

        angular.forEach(vm.repos, function (groupRepo) {
            var groupName = groupRepo.group;
            angular.forEach(groupRepo.repos, function (repo) {
                console.log("Evaluating repo", repo);

                if (repo.id) {
                    var data = { group: groupName, repo: repo };

                    //http://doc.gitlab.com/ce/api/branches.html
                    var url =
                        vm.gitLabCfg.baseUrl +
                        "/" +
                        vm.gitLabCfg.apiUri +
                        "/projects/" +
                        repo.id +
                        "/repository/branches/" +
                        branchName;

                    console.log("Looking for branch", branchName, JSON.stringify(data), url);

                    $http.get(url, vm.config).then(
                        function (response) {
                            console.log(
                                "(Found) Looking for branch",
                                branchName,
                                JSON.stringify(data),
                                url
                            );
                            vm.getRepoDetails(data);
                        },
                        function errorCallback(response) {
                            vm.searchInProgress = false;
                            if (response.status === 404) {
                                vm.notFound.push(url);
                            } else {
                                vm.errors.push("Error determining branch presence: " + url);
                                console.error(
                                    "Error determining branch presence: " + url,
                                    response
                                );
                            }
                        }
                    );
                }
            }); //end forEach entry.repos
        }); //end forEach entry
    };

    vm.getRepoDetails = function (data) {
        var deferred = $q.defer();

        var url =
            vm.gitLabCfg.baseUrl +
            "/" +
            vm.gitLabCfg.apiUri +
            "/projects/" +
            data.repo.id +
            "/merge_requests?state=opened";
        console.log("Looking for any related Merge Requests", vm.branch, data, url);

        $http.get(url, vm.config).then(
            function (response) {
                if (response && response.data) {
                    console.log("Merge Requests", response.data);
                    data.inbound = [];
                    data.toProd = [];
                    for (var i = 0; i < response.data.length; i++) {
                        var mr = response.data[i];
                        if (mr.target_branch === vm.branch) {
                            data.inbound.push(mr);
                        } else if (
                            mr.target_branch === "Production" &&
                            mr.source_branch === branch
                        ) {
                            data.toProd.push(mr);
                        }
                    }
                    var cnt = data.inbound.length + data.toProd.length;
                    console.log(
                        "Located [" + cnt + "] Related Merge Requests...",
                        cnt === 0 ? [] : data
                    );
                    console.log("..[" + data.toProd.length + "] toProd MRs", data.toProd);
                    console.log("..[" + data.inbound.length + "] inbound MRs", data.inbound);
                }

                vm.rslts.push(data);
                vm.searchInProgress = false;
                deferred.resolve(data);
            },
            function errorCallback(response) {
                vm.rslts.push(data);
                vm.searchInProgress = false;
                vm.errors.push("Error determining branch presence: " + url);
                console.error("Error determining branch presence: " + url, response);

                deferred.resolve(data);
            }
        );

        return deferred.promise;
    };

    vm.init();
};

BranchesViewController.$inject = ["$scope", "$http", "$stateParams", "$q", "$cookies"];

export default BranchesViewController;
